import React, { ReactNode, useState } from 'react';
// Import the App.css file
import '../App.css';
import { useAuth } from '../context/AuthContext';

// Add type for children
type ProviderProps = {
  children: ReactNode;
};

// Replace this with your own context or remove if not needed
const LanguageProvider = ({ children }: ProviderProps) => <>{children}</>;

const Layout = ({ children }: ProviderProps) => {
  // Add state for mobile menu
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const { user, isAuthenticated, isAdmin, isUser, isFormateur, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    window.location.href = '/'; // Optional: redirect to home after logout
  };

  // Toggle mobile menu
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Close mobile menu when clicking on a link
  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <div>
      <header className="border-b">
        <div className="container flex h-[110px] items-center justify-between px-4 md:px-6">
          <a href="/" className="flex items-center gap-2">
            <img src="/logo.png" alt="Elille Academy Logo" width={170} height={70} />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex gap-4 sm:gap-6">
            <a href="/" className="text-sm font-medium hover:underline underline-offset-4">
              accueil
            </a>
            <a href="/about" className="text-sm font-medium hover:underline underline-offset-4">
              Qui sommes-nous ?
            </a>
            <a href="/courses" className="text-sm font-medium hover:underline underline-offset-4">
              Formations
            </a>
            <a href="https://substack.com/@elilleacademy" className="text-sm font-medium hover:underline underline-offset-4">
              Blog
            </a>
            <a href="/contact" className="text-sm font-medium hover:underline underline-offset-4">
              Contact
            </a>
          </nav>

          {/* Desktop Auth Buttons */}
          <div className="hidden md:flex items-center gap-2">
            {isAuthenticated ? (
              <>
                {isAdmin ? (
                  <a href="/admin">
                    <button className="bg-[#00088E] text-white px-3 py-1 rounded hover:bg-blue-700">
                      Admin Dashboard
                    </button>
                  </a>
                ) : isFormateur ? (
                  <a href="/formateur">
                    <button className="bg-[#00088E] text-white px-3 py-1 rounded hover:bg-blue-700">
                      Mon espace
                    </button>
                  </a>
                ) : (
                  <a href="/dashboard">
                    <button className="bg-[#00088E] text-white px-3 py-1 rounded hover:bg-blue-700">
                      Mon espace
                    </button>
                  </a>
                )}
                <button
                  onClick={handleLogout}
                  className="border px-3 py-1 rounded border-[#00088E] text-[#00088E] hover:bg-blue-50"
                >
                  Se déconnecter
                </button>
              </>
            ) : (
              <>
                <a href="/signin">
                  <button className="border px-3 py-1 rounded border-[#00088E] text-[#00088E] hover:bg-blue-50">
                    Se connecter
                  </button>
                </a>
                <a href="/signup">
                  <button className="bg-[#00088E] text-white px-3 py-1 rounded hover:bg-blue-700">
                    S'inscrire
                  </button>
                </a>
              </>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-menu"
            >
              <line x1="4" x2="20" y1="12" y2="12"></line>
              <line x1="4" x2="20" y1="6" y2="6"></line>
              <line x1="4" x2="20" y1="18" y2="18"></line>
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden border-t bg-white">
            <nav className="container px-4 py-4 space-y-4">
              <a
                href="/"
                className="block text-sm font-medium hover:text-[#00088E]"
                onClick={closeMobileMenu}
              >
                Acceuil
              </a>
              <a
                href="/courses"
                className="block text-sm font-medium hover:text-[#00088E]"
                onClick={closeMobileMenu}
              >
                Formations
              </a>
              <a
                href="/contact"
                className="block text-sm font-medium hover:text-[#00088E]"
                onClick={closeMobileMenu}
              >
                Contact
              </a>

              {/* Mobile Auth Buttons */}
              <div className="pt-4 border-t space-y-3">
                {isAuthenticated ? (
                  <>
                    {isAdmin ? (
                      <a href="/admin" onClick={closeMobileMenu}>
                        <button className="w-full bg-[#00088E] text-white px-3 py-2 rounded hover:bg-blue-700">
                          Admin Dashboard
                        </button>
                      </a>
                    ) : (
                      <a href="/dashboard" onClick={closeMobileMenu}>
                        <button className="w-full bg-[#00088E] text-white px-3 py-2 rounded hover:bg-blue-700">
                          Mon espace
                        </button>
                      </a>
                    )}
                    <button
                      onClick={() => {
                        handleLogout();
                        closeMobileMenu();
                      }}
                      className="w-full border px-3 py-2 rounded border-[#00088E] text-[#00088E] hover:bg-blue-50"
                    >
                      Se déconnecter
                    </button>
                  </>
                ) : (
                  <>
                    <a href="/signin" onClick={closeMobileMenu}>
                      <button className="w-full border px-3 py-2 rounded border-[#00088E] text-[#00088E] hover:bg-blue-50">
                        Se connecter
                      </button>
                    </a>
                    <a href="/signup" onClick={closeMobileMenu}>
                      <button className="w-full bg-[#00088E] text-white px-3 py-2 rounded hover:bg-blue-700">
                        S'inscrire
                      </button>
                    </a>
                  </>
                )}
              </div>
            </nav>
          </div>
        )}
      </header>

      <main>{children}</main>

      <footer className="border-t py-6 md:py-8">
        <div className="container flex flex-col gap-4 md:flex-row md:gap-8 px-4 md:px-6">
          <div className="flex-1 space-y-4">
            <a href="/" className="flex items-center">
              <img src="/logo.png" alt="Elille Academy Logo" width={170} height={70} />
            </a>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Éducation à l'inclusion, la diversité et l'égalité de genre.
            </p>
          </div>
          <div className="flex-1 space-y-4">
            <div className="text-sm font-medium">Liens rapides</div>
            <nav className="flex flex-col gap-2 text-sm">
              <a href="/" className="hover:underline">
                Acceuil
              </a>
              <a href="/courses" className="hover:underline">
                Formations
              </a>
              <a href="/contact" className="hover:underline">
                Contact
              </a>
            </nav>
          </div>
          <div className="flex-1 space-y-4">
            <div className="text-sm font-medium">Légal</div>
            <nav className="flex flex-col gap-2 text-sm">
              <a href="/terms" className="hover:underline">
                Conditions d'utilisation
              </a>
              <a href="/privacy" className="hover:underline">
                Politique de confidentialité
              </a>
              <a href="/data-deletion" className="hover:underline">
                Suppression des données
              </a>
            </nav>
          </div>
          <div className="flex-1 space-y-4">
            <div className="text-sm font-medium">Nous contacter</div>
            <div className="text-sm text-gray-500 dark:text-gray-400">
              <p>contact@elilleacademy.com</p>
            </div>
          </div>
        </div>
        <div className="container mt-6 text-center text-xs text-gray-500 dark:text-gray-400 px-4 md:px-6">
          &copy; {new Date().getFullYear()} Elille Academy. Tous droits réservés.
        </div>
      </footer>
    </div>
  );
};

export default Layout;
